// Import logos from assets
import PrimaryLogo from '../assets/images/Logo/Svg/Primary/Primary.svg';
import SecondaryLogo from '../assets/images/Logo/Svg/Secondary/Secondary.svg';
import BrandmarkLogo from '../assets/images/Logo/Svg/Brandmark/Brandmark.svg';
import TextLogo from '../assets/images/Logo/Svg/Name/Type.svg';
// Cropped lockups (no built-in canvas padding) — use these in UI chrome
import HorizontalLogo from '../assets/images/Logo/Svg/logo-horizontal.svg';
import HorizontalLogoLight from '../assets/images/Logo/Svg/logo-horizontal-light.svg';

// Navigation Links
export const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About Us', href: '#about' },
  { name: 'Services', href: '#services' },
  { name: 'Contact Us', href: '#contact' },
];

// Brand/Logo Info
export const brandInfo = {
  name: 'INSITE',
  subtitle: 'INFRA',
  fullName: 'INSITE INFRA',
  description: 'Since 2014, delivering quality construction solutions including Kerala government works and private sector projects. Over 20+ successful projects completed across Kerala.',
  tagline: 'Building Your Dreams Into Reality',
  established: '2014',
  experience: '10+ Years of Excellence',
  logo: {
    primary: PrimaryLogo,
    secondary: SecondaryLogo,
    brandmark: BrandmarkLogo,
    text: TextLogo,
    horizontal: HorizontalLogo,
    horizontalLight: HorizontalLogoLight,
  },
};
